import * as React from 'react'
const SvgComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={136}
    height={137}
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    shapeRendering="geometricPrecision"
    vectorEffect="non-scaling-stroke"
    {...props}
  >
    <path
      fill="#fff"
      d="m104.72 87.748 2.165 13.156c0 .586.314 1.122.82 1.418l24.017 16.548c1.092.623 3.633-1.393 3.633-2.652v-12.724a3.732 3.732 0 0 0-1.875-3.238l-24.622-14.39c-1.085-.629-4.138.624-4.138 1.882Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m104.72 87.748 2.165 13.156c0 .586.314 1.122.82 1.418l24.017 16.548c1.092.623 3.633-1.393 3.633-2.652v-12.724a3.732 3.732 0 0 0-1.875-3.238l-24.622-14.39c-1.085-.629-4.138.624-4.138 1.882Z"
    />
    <path
      fill="#fff"
      d="M104.325 88.42v14.081c0 .586.278 1.16.783 1.449l25.714 14.822c1.085.623 2.442-.161 2.442-1.419v-12.724a3.75 3.75 0 0 0-1.875-3.244l-24.622-14.39a1.632 1.632 0 0 0-2.448 1.413"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M104.325 88.42v14.081c0 .586.278 1.16.783 1.449l25.714 14.822c1.085.623 2.442-.161 2.442-1.419v-12.724a3.75 3.75 0 0 0-1.875-3.244l-24.622-14.39a1.632 1.632 0 0 0-2.448 1.413l.006.012ZM108.723 94.211l19.255 11.207M108.723 97.388l19.255 11.213M108.723 100.564l19.255 11.213"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      fill="#fff"
      d="m31.28 27.131-2.165 13.156c0 .586-.314 1.122-.82 1.419L4.278 58.252C3.186 58.877.645 56.86.645 55.603V42.877c0-1.338.715-2.572 1.875-3.238l24.622-14.39c1.085-.628 4.138.624 4.138 1.882Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m31.28 27.131-2.165 13.156c0 .586-.314 1.122-.82 1.419L4.278 58.252C3.186 58.877.645 56.86.645 55.603V42.877c0-1.338.715-2.572 1.875-3.238l24.622-14.39c1.085-.628 4.138.624 4.138 1.882Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      fill="#fff"
      d="M31.681 27.803v14.081c0 .586-.278 1.16-.783 1.45L5.184 58.154c-1.085.624-2.442-.16-2.442-1.418V44.012a3.75 3.75 0 0 1 1.875-3.244l24.621-14.39c1.086-.629 2.45.16 2.45 1.413"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M31.681 27.803v14.081c0 .586-.278 1.16-.783 1.45L5.184 58.154c-1.085.624-2.442-.16-2.442-1.418V44.012a3.75 3.75 0 0 1 1.875-3.244l24.621-14.39c1.086-.629 2.45.16 2.45 1.413l-.007.012ZM27.277 33.594 8.021 44.801M27.277 36.771 8.021 47.984M27.277 39.954 8.021 51.16"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      fill="#fff"
      d="m31.107 57.73 27.36-15.79s1.092-.678 3.405.407c2.313 1.085 36.211 21.371 36.211 21.371l-.271 63.022-17.017 9.394-9.53-5.718-11.706 6.125-28.044-16.474-.408-62.344v.006Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m98.663 63.786-.962 62.812-16.82 9.659-9.794-5.711M98.521 63.558 81.288 73.63l-10.12-6.433-10.986 6.254c0-.296-.253 63.226-.253 63.226l-28.285-16.104-.277-63.09 26.854-15.29a2.889 2.889 0 0 1 2.862 0l37.432 21.365h.006ZM31.348 57.501l28.588 16.036"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M71.087 67.228s-.234 63.552 0 63.318l-11.151 6.125"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m35.709 57.865 23.789 13.211c.16.087.351.087.512 0l9.541-5.205a2.584 2.584 0 0 1 2.578.062l8.944 5.44a.39.39 0 0 0 .4 0l12.977-7.525a.393.393 0 0 0 0-.679L60.392 43.821a1.46 1.46 0 0 0-1.456 0L35.71 56.94a.528.528 0 0 0 0 .919v.006ZM81.307 73.827v61.869M34.537 62.978l4.835 2.88v57.2l-4.835-3.071V62.978ZM42.438 67.228l4.835 2.886v57.194l-4.835-3.065V67.228ZM50.339 71.483l4.835 2.887v57.194l-4.835-3.072V71.483ZM96.258 67.474l-4.83 2.887v57.193l4.83-3.071V67.474ZM88.48 72.458l-4.83 2.886v57.194l4.83-3.071v-57.01Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      fill="#fff"
      d="M86.513 30.06c.172-5.507-2.209-12.249-5.354-17.294C75.12 3.07 66.887-2.271 60.694 1.584c-.931.58-8.259 4.52-8.259 4.52s-2.294 11.874 1.13 19.152c.425.9 9.276 30.037 9.276 30.037l10.645-6.988c.068-.043 8-7.47 9.739-9.48 2.239-2.788 3.214-6.507 3.288-8.765Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M86.513 30.06c.172-5.507-2.209-12.249-5.354-17.294C75.12 3.07 66.887-2.271 60.694 1.584c-.931.58-8.259 4.52-8.259 4.52s-2.294 11.874 1.13 19.152c.425.9 9.276 30.037 9.276 30.037l10.645-6.988c.068-.043 8-7.47 9.739-9.48 2.239-2.788 3.214-6.507 3.288-8.765Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      fill="currentColor"
      className="gray-element"
      d="M74.035 16.923C67.997 7.228 58.085 2.497 51.893 6.352c-5.496 3.423-6.211 12.453-2.091 21.217.518 1.104 12.78 27.946 12.977 27.817.068-.05 3.528-3.3 6.988-6.76 1.782-1.783 3.935-3.75 5.668-5.761 2.24-2.788 3.004-6.094 3.072-8.357.172-5.508-1.326-12.54-4.466-17.585M68.59 34.267c-3.22 2.005-8.376-.456-11.51-5.495-3.139-5.04-3.07-10.75.149-12.755 3.22-2.005 8.376.456 11.509 5.495 3.14 5.04 3.072 10.75-.148 12.755Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M73.616 30.425c-3.22 2.004-8.376-.457-11.51-5.496-3.139-5.039-3.071-10.75.149-12.755"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
)
export default SvgComponent
